import WorldZone from "../enum/WorldZone";

export default class WorldEventConstants {
    public static actionTriggerableZones = [
        WorldZone.ABOUT_ME,
        WorldZone.INTERNSHIP,
        WorldZone.PROJECTS
    ];
}
